












































































































import { Vue, Component } from 'vue-property-decorator';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import SecondaryButton from '@/components/Buttons/SecondaryButton/index.vue';
import FilterIcon from '@/components/Icons/FilterIcon/index.vue';
import ToolTipIcon from '@/components/Icons/ToolTipIcon/index.vue';
import DeleteIcon from '@/components/Icons/DeleteIcon/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import Dropdown from '@/components/Form/Dropdown/index.vue';
import SelectionDropdown from '@/components/Form/SelectionDropdown/index.vue';
import Searchfield from '@/components/Form/Searchfield/index.vue';
import FirstCheckBox from '@/components/Selection/FirstCheckBox/index.vue';
import SecondCheckBox from '@/components/Selection/SecondCheckBox/index.vue';
import TableCard from '@/components/Table/TableCard/index.vue';
import DataTable from '@/components/Table/DataTable/index.vue';
import StandardCard from '@/components/Card/StandardCard/index.vue';
import Modal from '@/components/Modal/index.vue';

@Component({
  components: {
    PrimaryButton,
    SecondaryButton,
    FilterIcon,
    ToolTipIcon,
    DeleteIcon,
    Textfield,
    Dropdown,
    SelectionDropdown,
    Searchfield,
    FirstCheckBox,
    SecondCheckBox,
    TableCard,
    DataTable,
    StandardCard,
    Modal,
  },
})
export default class Library extends Vue {
  public async sampleFunction() {
    this.$router.push({ name: 'login' });
  }

  private headers = [
    {
      text: 'Col 1',
      align: 'center',
      value: 'colone',
    },
    {
      text: 'Col 2',
      align: 'center',
      value: 'coltwo',
    },
  ]

  private desserts = [
    {
      colone: 'Text1',
      coltwo: 'Text1',

    },
    {
      colone: 'Text2',
      coltwo: 'Text2',

    },
  ]

  private items = [
    {
      text: 'Partner',
      value: 'partner',
    },
    {
      text: 'Market',
      value: 'city',
    },
    {
      text: 'Scout',
      value: 'scout',
    },
    {
      text: 'Status',
      value: 'status',
    },
  ]

  private selection = [
    {
      status: 'inactive',
    },
    {
      status: 'active',
    },
  ];
}

